import { createSlice } from '@reduxjs/toolkit';

import type { ClasseJudicialState } from '@/types/classeJudicial/classeJudicialTypes';

import {
  buscarClasseJudicialPorId,
  buscarClassePorCodigo,
  buscarClassesPorTipoJusticaEGrau,
  listarClassesJudiciais,
} from './actions';

const initialState: ClasseJudicialState = {
  classes: [],
  currentClasse: null,
  total: 0,
  page: 1,
  limit: 100,
  isLoading: false,
  error: null,
};

const classeJudicialSlice = createSlice({
  name: 'classeJudicial',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentClasse: (state) => {
      state.currentClasse = null;
    },
    clearClasses: (state) => {
      state.classes = [];
      state.total = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarClassesJudiciais.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarClassesJudiciais.fulfilled, (state, action) => {
        state.isLoading = false;
        state.classes = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(listarClassesJudiciais.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarClasseJudicialPorId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarClasseJudicialPorId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentClasse = action.payload;
      })
      .addCase(buscarClasseJudicialPorId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarClassesPorTipoJusticaEGrau.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarClassesPorTipoJusticaEGrau.fulfilled, (state, action) => {
        state.isLoading = false;
        state.classes = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(buscarClassesPorTipoJusticaEGrau.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarClassePorCodigo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarClassePorCodigo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentClasse = action.payload;
      })
      .addCase(buscarClassePorCodigo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearClasses } = classeJudicialSlice.actions;
export default classeJudicialSlice.reducer;
